import {
  MobileHeaderOptionsContext,
  MobileHeaderSetterContext,
  type MobileHeaderOptions,
} from "@/contexts/mobile-header-context";
import { useContext, useLayoutEffect } from "react";

/** Read by the header itself. */
export function useMobileHeaderOptions(): MobileHeaderOptions {
  return useContext(MobileHeaderOptionsContext);
}

/**
 * Sets the mobile header for the screen that calls it, and clears it when that
 * screen goes — the next one starts from a bare header with the menu button.
 * Outside the mobile layout (the desktop tree) it does nothing.
 */
export function useMobileHeader({
  title,
  onBack,
  isMenuDisabled,
  isConnectionSlow,
}: MobileHeaderOptions): void {
  const setOptions = useContext(MobileHeaderSetterContext);

  useLayoutEffect(() => {
    setOptions({ title, onBack, isMenuDisabled, isConnectionSlow });
  }, [setOptions, title, onBack, isMenuDisabled, isConnectionSlow]);

  useLayoutEffect(() => () => setOptions({}), [setOptions]);
}
